import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

export const iconButtonsContainerStyle = css`
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  /* For now, we hide this one */
  display: none;
`

export const iconButtonStyle = css`
  padding: 8px;
  background: ${colors.SECONDARY_400};
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;
`
